/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Mixins
import settings from './settings';

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import CountriesPicker from 'shared/ui/components/form-components/pickers/CountriesPicker.vue';
import Dialog from 'shared/ui/components/modals/DialogComponent.vue';
import LanguagePicker from 'shared/ui/components/form-components/pickers/LanguagePicker.vue';
import TypesOptions from 'ui/components/wizards/create-workspace/TypesOptions.vue';

const __vue_script__ = {
    name: 'Logistics',

    components: { BaseInput, BaseSelect, CountriesPicker, LanguagePicker, TypesOptions },

    mixins: [settings],

    data() {
        return {
            classification: {},
            classifications: [],
            countries: this.$utils.collections.getCountryListForSelect(),
            showCustomClassification: false,
            timezones: this.$utils.time.getAllZones(),
            timezone: '',
            traits: {},
            innerValue: {
                description: {
                    venue: {
                        city: ''
                    }
                },
                languages: [],
                timezone: this.$utils.time.DEFAULT_TIMEZONE_IDENTIFIER,
                traits: {
                    country_code: []
                }
            }
        };
    },

    watch: {
        timezone(newTz, oldTz) {
            this.innerValue.timezone = newTz;
            if (!oldTz || !newTz || newTz === oldTz) {
                return;
            }

            this.$modal.show(Dialog, {
                title: this.$t('general_settings.messages.tz_change_title'),
                text: this.$t('general_settings.messages.tz_change'),
                buttons: [{
                    title: this.$t('general.close'),
                    default: true,
                    handler: () => this.$modal.hide('tz-change'),
                    class: 'btn btn-primary'
                }],
            }, {
                name: 'tz-change',
                classes: 'small',
                reset: true,
                height: 'auto'
            });
        },

        traits: {
            deep: true,
            handler(newVal, oldVal) {
                if (!this.canAccessOrgData) {
                    return;
                }

                if (newVal.audience_type !== oldVal?.audience_type) {
                    this.loadClassifications();
                }

                Object.assign(this.innerValue.traits, this.traits);
            }
        },

        classification() {
            this.$set(this.traits, 'event_classification', this.classification?.value);
            this.showCustomClassification = this.traits.event_classification === 'other';
        }
    },

    methods: {
        async init() {
            this.innerValue.description.venue.city = get(this.event, 'description.venue.city', '');
            this.innerValue.languages = this.event.languages;
            this.timezone = this.innerValue.timezone = this.event.timezone;
            this.innerValue.traits.country_code = get(this.event, 'traits.country_code', []);
            this.traits.event_format = get(this.event, 'traits.event_format', '');
            this.traits.audience_type = get(this.event, 'traits.audience_type', '');
            this.traits.event_scope = get(this.event, 'traits.event_scope', '');
            this.traits.expected_attendance = get(this.event, 'traits.expected_attendance', '');
            this.traits.event_custom_classification = get(this.event, 'traits.event_custom_classification', '');
            await this.loadClassifications();
            this.ready = true;
        },

        preSubmitHook() {
            if (this.innerValue.traits.event_classification !== 'other') {
                this.innerValue.traits.event_custom_classification = null;
            }
        },

        async loadClassifications() {
            try {
                this.ready = false;
                const orgName = this.$services.org.getNameFromId(this.event.ownerId);
                this.classifications = await this.$services.org.getCreationOptions(orgName, this.traits.audience_type);
                this.classification = this.classifications.find(c => c.value === get(this.event, 'traits.event_classification', ''));
            } catch (error) {
                console.error('[Logistics] Could not initialize the component', error);
            } finally {
                this.ready = true;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('validation-observer',{ref:"form",staticClass:"logistics",attrs:{"tag":"form","autocomplete":"off"}},[_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.languages')))]),_c('p',[_vm._v(_vm._s(_vm.$t('general_settings.form.languages_hint')))]),_c('div',{staticClass:"default-language-info alert alert-info"},[_c('p',[_vm._v(_vm._s(_vm.$t('general_settings.form.default_language_info')))])]),_c('validation-provider',{attrs:{"slim":true}},[_c('language-picker',{attrs:{"disabled":!_vm.canChangeSettings,"name":"languages"},model:{value:(_vm.innerValue.languages),callback:function ($$v) {_vm.$set(_vm.innerValue, "languages", $$v)},expression:"innerValue.languages"}})],1)],1),_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.location')))]),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"country"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('countries-picker',{attrs:{"name":"country","label":_vm.$t('general_settings.form.country'),"errors":errors,"disabled":!_vm.canChangeSettings,"placeholder":_vm.$t('general_settings.form.country_placeholder'),"tip":_vm.$t('general_settings.form.country_tip'),"multiple":true},model:{value:(_vm.innerValue.traits.country_code),callback:function ($$v) {_vm.$set(_vm.innerValue.traits, "country_code", $$v)},expression:"innerValue.traits.country_code"}})]}}],null,false,1128258087)}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"location"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"type":"text","name":"location","label":_vm.$t('general_settings.form.city'),"disabled":!_vm.canChangeSettings,"errors":errors},model:{value:(_vm.innerValue.description.venue.city),callback:function ($$v) {_vm.$set(_vm.innerValue.description.venue, "city", $$v)},expression:"innerValue.description.venue.city"}})]}}],null,false,886201284)}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"timezone"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{ref:"timezone",attrs:{"errors":errors,"label":_vm.$t('general_settings.form.timezone'),"options-label":null,"options":_vm.timezones,"disabled":!_vm.canChangeStartDate || !_vm.canChangeSettings,"placeholder":_vm.$t('general_settings.form.timezone_placeholder'),"tip":_vm.$t('general_settings.form.timezone_tip'),"name":"timezone"},model:{value:(_vm.timezone),callback:function ($$v) {_vm.timezone=$$v},expression:"timezone"}})]}}],null,false,119583104)})],1),(_vm.canAccessOrgData)?_c('types-options',{attrs:{"keep":true,"disabled":!_vm.canChangeSettings},model:{value:(_vm.traits),callback:function ($$v) {_vm.traits=$$v},expression:"traits"}},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"event_classification"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{attrs:{"name":"event_classification","track-by":"value","errors":errors,"disabled":!_vm.canChangeSettings,"label":_vm.$t('general_settings.form.event_type'),"options":_vm.classifications},model:{value:(_vm.classification),callback:function ($$v) {_vm.classification=$$v},expression:"classification"}})]}}],null,false,2850438575)}),(_vm.showCustomClassification)?_c('div',{staticClass:"feature-dependant"},[_c('validation-provider',{attrs:{"slim":true}},[_c('base-input',{attrs:{"label":_vm.$t('wizards.create_workspace.form.event_custom_classification'),"disabled":!_vm.canChangeSettings,"name":"event_custom_classification","type":"text"},model:{value:(_vm.traits.event_custom_classification),callback:function ($$v) {_vm.$set(_vm.traits, "event_custom_classification", $$v)},expression:"traits.event_custom_classification"}})],1)],1):_vm._e()],1):_vm._e()],1):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Logistics.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__